import React from 'react';
import { Phone } from 'lucide-react';
import { businessData } from '../mock';

const About = () => {
  return (
    <div className="page-about">
      {/* Hero */}
      <section className="page-hero">
        <div className="page-hero-content">
          <h1 className="page-title">Om Herrefrisør</h1>
          <p className="page-subtitle">
            Tradition, kvalitet og over 50 års erfaring på Nørrebro
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section className="story-section">
        <div className="story-container">
          <div className="story-grid">
            <div className="story-image-wrapper">
              <img
                src={businessData.images.vintage}
                alt="Vintage barbershop"
                className="story-image"
              />
            </div>
            <div className="story-content">
              <h2 className="story-title">Historien om Ole</h2>
              <p className="story-text">
                Ole har klippet hår på Nørrebro i over 50 år. Det startede i
                1970'erne, hvor han åbnede sin egen salon på Thorsgade med en
                enkelt vision: At tilbyde klassisk herreklip uden genveje,
                hastværk eller moderne pjat.
              </p>
              <p className="story-text">
                I dag er Herrefrisør en af de sidste autentiske frisørsaloner
                af sin slags i København. Her er ingen online booking, ingen
                touch screens, og ingen Instagram-venlige spejle.
              </p>
              <p className="story-text">
                I stedet finder du brun træindretning, dagens avis, en rolig
                atmosfære og en frisør der tager sig tid til hver eneste kunde.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="values-container">
          <h2 className="section-title-center">Vores værdier</h2>
          <div className="values-grid">
            <div className="value-card">
              <h3 className="value-title">Erfaring</h3>
              <p className="value-text">
                Med over 50 års erfaring kender Ole håndværket til fingerspidserne.
                Hver klipning er et resultat af årtiers praktisk viden.
              </p>
            </div>
            <div className="value-card">
              <h3 className="value-title">Kvalitet</h3>
              <p className="value-text">
                Vi går aldrig på kompromis med kvaliteten. Klassisk herreklip
                udført med saks og maskine, som det altid har været.
              </p>
            </div>
            <div className="value-card">
              <h3 className="value-title">Autenticitet</h3>
              <p className="value-text">
                Ingen moderne trends eller gimmicks. Bare ægte håndværk,
                personlig service og en bramfri, hyggelig atmosfære.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Image Section */}
      <section className="about-image-section">
        <div className="about-image-container">
          <img
            src={businessData.images.about}
            alt="Ole klipper kunde"
            className="about-full-image"
          />
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="philosophy-section">
        <div className="philosophy-container">
          <h2 className="section-title-center">Vores filosofi</h2>
          <div className="philosophy-content">
            <p className="philosophy-text">
              "En god klipning tager tid. Man kan ikke skynde sig igennem
              håndværk og forvente kvalitet. Hver kunde fortjener min fulde
              opmærksomhed – og det er præcis, hvad de får."
            </p>
            <p className="philosophy-author">– Ole, Herrefrisør</p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="about-cta-section">
        <div className="about-cta-container">
          <h2 className="about-cta-title">Oplev forskellen selv</h2>
          <p className="about-cta-text">
            Kom forbi og mærk autenticiteten. Ring til os for at aftale en tid.
          </p>
          <a href={`tel:${businessData.phone}`} className="cta-button">
            <Phone size={20} />
            Ring til os
          </a>
        </div>
      </section>
    </div>
  );
};

export default About;